import { Component, HostListener, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sankey-chart',
  templateUrl: './sankey-chart.component.html',
  styleUrl: './sankey-chart.component.scss',
})
export class SankeyChartComponent {
  @Input() loading = true;
  @Input() series: { links: any[]; data: any[] };

  chartOption: echarts.EChartsOption;
  chartInstance: echarts.ECharts | null = null;

  isLoading = true;
  chartHeight = 400;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  constructor(private translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateChartOptions();

    if (changes['loading']) {
      setTimeout(() => {
        this.isLoading = this.loading;
      }, 333);
    }
  }

  ngOnInit(): void {
    this.updateChartOptions();
  }

  getNameById(id: string) {
    const node = this.series.data.find((item) => item.id === id);
    return node ? node.name : id;
  }

  mapLink(link: { source: string; target: string; value: number }) {
    return {
      source: this.getNameById(link.source),
      target: this.getNameById(link.target),
      value: link.value,
    };
  }

  updateChartOptions() {
    this.chartHeight =
      this.series?.data.length > 40 ? this.series.data.length * 5 + 400 : 400;

    this.chartOption = {
      tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove',
        formatter: (params) => {
          // For nodes, ECharts gives params.name and params.value (sum of flows in/out)
          // For links, ECharts gives params.data.source, params.data.target, and params.value
          if (params.dataType === 'node') {
            return `<div style="max-width:300px; white-space:normal; word-break:break-word;">
                <b>${this.getNameById(params.name)}</b><br/>
                ${this.translate.instant('charts.labels.total')}: ${
              params.value
            }
              </div>`;
          } else if (params.dataType === 'edge') {
            return `<div style="max-width:300px; white-space:normal; word-break:break-word;">
                <b>${this.getNameById(
                  params.data.source
                )} ➡️ ${this.getNameById(params.data.target)}</b><br/>
                ${this.translate.instant('charts.labels.count')}: ${
              params.value
            }
              </div>`;
          }
          return '';
        },
      },
      label: {
        show: true,
        formatter: (d) => {
          const text = this.getNameById(d.name);
          return text.length > 40 ? text.slice(0, 40) + '…' : text;
        },
      },
      series: {
        type: 'sankey',
        emphasis: {
          focus: 'adjacency',
        },
        left: '0%',
        nodeAlign: 'right',
        nodeWidth: 20,
        links: this.series?.links || [],
        nodes: this.series?.data.map((item) => ({ name: item.id })) || [],
        lineStyle: {
          color: 'source',
          curveness: 0.2,
        },
      },
    };
  }

  ngOnDestroy(): void {}

  onChartInit(ec: any) {
    this.chartInstance = ec;
  }
}
